/// <reference path="../../../Modules/Attr/Grid/NoboxEntityGrid.ts" />
namespace Nobox.Administration {

    @Serenity.Decorators.registerClass()
    export class AgentComparisonGrid extends NoboxEntityGrid<any, any> {
        protected getColumnsKey() { return AgentComparisonColumns.columnsKey; }
        protected getDialogType() { return UserDialog; }
        protected getIdProperty() { return UserRow.idProperty; }
        //protected getIsActiveProperty() { return UserRow.isActiveProperty; }
        protected getLocalTextPrefix() { return UserRow.localTextPrefix; }
        protected getService() { return UserService.baseUrl; }
        constructor(container: JQuery) {
            super(container);
            this.setTitle("Agent Performance");
        }
        protected getButtons(): Serenity.ToolButton[] {
            var $this = this;
            var buttons = super.getButtons();
            buttons.splice(0, 1);
            return buttons;
        }
        protected getQuickFilters() {
            var flt = super.getQuickFilters();

            var filter1 = Q.first(flt, x => x.field == UserRow.Fields.Date);
            filter1.handler = h => {
                const request = (h.request as UserListRequest);
                const start = (h.widget as CustomDateFilter).get_value();
                const end = (h.widget as CustomDateFilter).end_get_value();
                if (h.active) {
                    request.SDateAgentComparison = start;
                    request.EDateAgentComparison = end;
                    h.handled = true;
                } else {
                    request.SDateAgentComparison = null;
                    request.EDateAgentComparison = null;
                    h.handled = true;
                }
            };
            return flt;
        }

        protected getColumns(): Slick.Column[] {
            var columns = super.getColumns();

            Q.first(columns, x => x.field == UserRow.Fields.ReCon).format =
                ctx => `<a href="javascript:;" class="resolved-link">${ctx.value}</a>`;
            Q.first(columns, x => x.field == UserRow.Fields.AssCon).format =
                ctx => `<a href="javascript:;" class="assigned-link">${ctx.value}</a>`;

            return columns;
        }

        protected onClick(e: JQueryEventObject, row: number, cell: number): void {

            // let base grid handle clicks for its edit links
            super.onClick(e, row, cell);
            // if base grid already handled, we shouldn"t handle it again
            if (e.isDefaultPrevented()) {
                return;
            }

            // get reference to current item
            var item = this.itemAt(row);

            // get reference to clicked element
            var target = $(e.target);

            if (target.hasClass("resolved-link")) {
                e.preventDefault();

                let dlg = new Nobox.AgentComparisonResolvedConversationDialog();
                dlg.agentId = item.UserId;
                dlg.agentNm = item.DisplayName;
                dlg.dialogOpen();
            }else if (target.hasClass("assigned-link")) {
                e.preventDefault();

                let dlg = new Nobox.AgentComparisonAssignedConversationDialog();
                dlg.agentId = item.UserId;
                dlg.agentNm = item.DisplayName;
                dlg.dialogOpen();
            }
        }
        protected getViewOptions() {
            let opt = super.getViewOptions();
            opt.rowsPerPage = 20;
            opt.url = Q.resolveUrl('~/Services/' + this.getService() + '/ListAgentComparison')
            return opt;
        }
        protected onViewSubmit(): boolean {
            if (!super.onViewSubmit()) { return false; }
            let request = this.view.params as UserListRequest;
            request.IncludeColumns = ["TenantId", "DisplayName", "ReCon", "MsgSent", "AssCon"]
            //request.ColumnSelection = 1;
            return true;
        }
    }
}